// extracted by mini-css-extract-plugin
export default {"root":"AfterFooterEmptySpace_root__x-XG0","platesBottomNavigation":"AfterFooterEmptySpace_platesBottomNavigation__1MaD4"};